import { SvgBase } from "../svg.base";

export const Edit = () => (
  <SvgBase>
   <g fill="none" fillRule="evenodd">
        <g fill="#B8B8B8" fillRule="nonzero">
            <g>
                <g>
                    <path d="M18.405 1.875c.989-.006 1.94.383 2.64 1.08.697.7 1.085 1.649 1.08 2.639-.007.988-.409 1.932-1.11 2.617L8.781 20.444c-.08.08-.18.138-.29.166l-5.825 1.494c-.466.12-.89-.304-.77-.77l1.492-5.825.005-.02.015-.046.012-.028c.03-.073.075-.141.134-.2l.019-.019L15.782 2.99c.69-.706 1.635-1.107 2.623-1.115zM4.34 16.892l-.952 3.72 3.722-.955-2.77-2.765zM15.884 4.676L4.898 15.662l3.441 3.434L19.322 8.113l-3.438-3.437zm2.53-1.535c-.65.005-1.273.269-1.732.739l.1-.096 3.435 3.433c.364-.397.587-.903.633-1.437l.01-.194c.003-.651-.253-1.276-.711-1.736-.46-.458-1.085-.713-1.735-.71z" transform="translate(-16.000000, -167.000000) translate(16.000000, 136.000000) translate(0.000000, 31.000000)"/>
                </g>
            </g>
        </g>
    </g>
  </SvgBase>
);